module.exports = __webpack_public_path__ + "static/img/6.1f76bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/admin/6.png
// module id = 2Mir
// module chunks = 0